<template>
  <ul :class="itemClass">
    <template v-for="(item, index) in sidebarItems" :key="index">
      <list-item v-if="checkPermissions(item) && showable(item)" :item="item" :index="item.name" :is-child="isChild" />
    </template>
  </ul>
</template>

<script setup>
import { inject, computed } from 'vue'

import { useStore } from 'vuex'

import { useRouter } from 'vue-router'

import ListItem from '@/components/ListItem.vue'
const router = useRouter()

const props = defineProps({
  listItems: {
    type: Array,
    default: () => []
  },
  itemClass: {
    type: String
  },
  header: {
    type: Boolean,
    default: false
  },
  isChild: {
    type: Boolean,
    default: false
  },
  user: {
    type: Object
  }
})

const vueCan = inject(['VueCan'])

const store = useStore()

const user = computed(() => store.state.retailerAuth.user)

const sidebarItems = computed(() => {
  let listItemslist = props.listItems
  const firstPathSegment = window.location.pathname.split('/').filter(pathName => pathName)[0]

  if (firstPathSegment === 'admin') {
    return listItemslist
  }

  const noSalesChannels = user.value.retailer.sales_channels?.length === 0

  if (noSalesChannels === false) {
    return listItemslist
  }

  return listItemslist.filter(item => {
      const resolved = router.resolve({ name: item.name })
      const routeMeta = resolved.meta || {}
      
      if (typeof routeMeta.allowWithoutSalesChannels === 'function') {
        return routeMeta.allowWithoutSalesChannels(user.value.retailer)
      }
      
      return false
  })
})

const checkPermissions = item => {
  if (item.permission) {
    if (item.permission === 'owner') {
      const roles = item.roles !== undefined ? item.roles : []
      return vueCan.$retailerCan(props.user, roles)
    } else {
      return vueCan.$can(item.permission)
    }
  } else if (item.child && !item.permission) {
    // Check parent item permission with child permission
    let canShowParentItem = false
    let perms = []

    item.child.forEach(childItem => {
      if (childItem.permission) {
        perms.push(childItem.permission)
      }

      if (childItem.child) {
        childItem.child.forEach(ci => {
          if (ci.permission) {
            perms.push(ci.permission)
          }
        })
      }
    })

    // if not have any child permission
    if (perms.length === 0) {
      return true
    }

    perms.forEach(perm => {
      if (vueCan.$can(perm)) {
        canShowParentItem = true
      }
    })

    return canShowParentItem
  } else {
    return true
  }
}

const showable = item => {
  if (item.hasOwnProperty('show')) {
    return item.show()
  }

  return true
}
</script>

<style scoped></style>
